import { Subscription } from '@models/client'

export const SubscriptionKindName = {
  gold: 'złoty',
  silver: 'srebrny',
  brown: 'brązowy',
  gray: 'szary',
}

export const getSubscriptionName = (subscription: Subscription): string => {
  if (subscription.type === 'BOOKING_IMPROVEMENT') return `Pakiet ${subscription.type_display}`
  return `Pakiet prywatny ${SubscriptionKindName[subscription.kind]}`
}
